<staff-layout-component *ngIf="showStaffLayout()"></staff-layout-component>
<main #routeContainer class="route-container" [class.sign-in-page]="isSignInPage()" [@routeAnimation]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</main>

<app-logout-confirmation-modal
  [isOpen]="staffLogoutService.showConfirmationModal()"
  [variant]="staffLogoutService.logoutConfirmationVariant()"
  (onLogoutClick)="staffLogoutService.confirmLogout()"
  (onSaveAndExitClick)="staffLogoutService.confirmSaveAndExit()"
  (onCancelClick)="staffLogoutService.cancelLogout()">
</app-logout-confirmation-modal>

